/*!
 *
 * Util模块 React Native module
 * 主要提供工具方法
 *
 */
const { Toast } = require("antd-mobile/lib");
var CryptoJS=require('crypto-js')
const keySize = 128;
const initKey = '@AmcFortune2019';
const fillKey = (key) => {
  const filledKey = Buffer.alloc(keySize / 8);
  const keys = Buffer.from(key);
  if (keys.length < filledKey.length) {
    filledKey.map((b, i) => filledKey[i] = keys[i]);
  }
  return filledKey;
}

module.exports = {
  encrypt: (password) => {
    let keyStr = 'chinaamc@app&web';
    let key = CryptoJS.enc.Utf8.parse(keyStr);
    let plaint = CryptoJS.enc.Utf8.parse(password);
    let encryptedData = CryptoJS.AES.encrypt(plaint, key, {
        mode: CryptoJS.mode.ECB,
        padding: CryptoJS.pad.Pkcs7
    });
    return window.encodeURIComponent(encryptedData.toString());
  },
  aesEncrypt: (data,key=initKey) => {
      const key2 = CryptoJS.enc.Utf8.parse(fillKey(key));
      const cipher = CryptoJS.AES.encrypt(data, key2, {
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7,
      iv: '',
    });
    // 将加密后的数据转换成 Base64
    const base64Cipher = cipher.ciphertext.toString(CryptoJS.enc.Base64);
    return base64Cipher;
  },
  hdUrl:'http://chinaamc-charlie.izhida.cn/?content=',
  return_enterType:'华夏财富H5',
  //获取url中的参数值
  // getQueryString:function(name) {
  //   let home_url = sessionStorage.getItem('home_url');
  //   const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)');
  //   const r =  home_url.substring((window.location.hash.search(/\?/)) + 1).match(reg);
  //   console.log(r);
  //   if (r != null) {
  //       return decodeURIComponent(r[2]);
  //   }
  // },
  getQueryString: (name) =>{
    let home_url = sessionStorage.getItem('home_url');
    console.log(home_url,"home_urlhome_url")
    let result = home_url.match(new RegExp("[\?\&]" + name + "=([^\&]+)", "i"));
    if (result == null || result.length < 1) {
        return "";
    }
    return result[1];
},


  return_Clinet_Type:function(){
    //第三方客户字典
    let venderType = {
      'v001':'hxcfH5ZX',//中信联盟 优享家
      'v002':'hxcfH5V002',//中信证券
    }
    let ua=navigator.userAgent.toLowerCase();
    let home_url = sessionStorage.getItem('home_url');
    if(ua.indexOf("amcfmapp")>-1) {
      return 'hxcfH5GJ'
    }else if(ua.includes("miniprogram")) {
      return 'hxcfMinpH5'
    } else if(ua.match(/MicroMessenger/i)=="micromessenger"){
      if (home_url && home_url.indexOf('venderType')>-1) {
        let id = this.getQueryString('venderType');
        return venderType[id];
      } else {
        return 'hxcfH5WX'
      }
    }else if(home_url && home_url.indexOf('venderType')>-1) {
      let id = this.getQueryString('venderType');
      return venderType[id];
    }else {
      return 'hxcfH5'
    }
  },
  ToastTime:2,
  parsePrice:function(s, isFloat){
    if (s!=undefined&&s!="-"&&s!=""&&s!=null&&s!='--') {
      s=Math.floor(s*100)/100
      let n = 2
       s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(n) + "";   
       var l = s.split(".")[0].split("").reverse(),   
       r = s.split(".")[1];   
       let t = ""; 
       if (s>=0) {//正负
            for(let i = 0; i < l.length; i ++ ){   
              t += l[i] + ((i + 1) % 3 == 0 && (i + 1) != l.length ? "," : "");   
            }   
            if(isFloat != undefined) {
              return t.split("").reverse().join("");
            }else {
              return t.split("").reverse().join("") + "." + r;
            }
       } else{
            for(let i = 0; i < l.length-1; i ++ ){   
              t += l[i] + ((i + 1) % 3 == 0 && (i + 1) != l.length-1 ? "," : "");  
            }  
            if(isFloat != undefined) {
              return "-"+t.split("").reverse().join("");
            }else {
              return "-"+t.split("").reverse().join("") + "." + r;
            }
       };    
    }else{
        return "0.00";
    }
  },
  //千分位转number
  priceParse: function (num) {
    if(num.indexOf(",") != -1) {
      num = num.split(",").join("");
    }
    return num;
  },
  tokenTime:1000*3600*1.5,
  regular1:/^(([1-9][0-9]*)|(([0]\.\d{1,2}|[1-9][0-9]*\.\d{1,2})))$/,
  errorTxt:'网络异常,请检查您的网络',
  imgUrl:window.urlObj.imgUrl, //测试CMS图片地址
  url:window.urlObj.url,

  backgroundColor:'rgba(242,245,247,1)',
  /**
   * 基于fetch的get方法
   * @method post
   * @param {string} url
   * @param {function} callback 请求成功回调
   */
  get: function(url,params, successCallback, failCallback, timeout = 30){
    if (params) {
        let paramsArray = [];
        //拼接参数
        Object.keys(params).forEach(key => paramsArray.push(key + '=' + params[key]))
        if (url.search(/\?/) === -1) {
            url += '?' + paramsArray.join('&')
        } else {
            url += '&' + paramsArray.join('&')
        }
    }
    console.log(url,"********");
    fetch(url, {  
    method: 'GET',timeout: timeout,mode:'cors',cache:'no-cache'
      })
      .then((response) => response.text())
      .then((responseText) => {
        successCallback(JSON.parse(responseText));
      })
      .catch(function(err){
        failCallback(err);
      });
  },
  post: function(url, params, successCallback, failCallback, timeout = 30){
    let paramsForm = new FormData();
    // for (let i in params) {
    //   console.log(params[i])
    //   paramsForm.append(i + '', params[i]);
    // }
    // paramsForm=JSON.stringify(paramsForm)
    let data='';
    if (params) {
        let paramsArray = [];
        //拼接参数
        Object.keys(params).forEach(key => paramsArray.push(key + '=' + params[key]))
        if (url.search(/\?/) === -1) {
            data += '' + paramsArray.join('&')
        } else {
            data += '' + paramsArray.join('&')
        }
    }
    console.log(data,paramsForm, url);
    fetch(url,{
        method: "POST",
        mode: 'cors',
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body:data,
      })
      .then((response) => response.json())
      .then((responseText) => {
        successCallback(responseText);
      })
      .catch(function(err){
        failCallback(err);
      });
  },
  postNew: function(url, params, successCallback, failCallback, timeout = 30){
    console.log(url);
    console.log(JSON.stringify(params));
    fetch(url,{
        method: "POST",
        mode: 'cors',
        headers: {
          "Content-Type": "application/json",
        },
        body:JSON.stringify(params),
      })
      .then((response) => response.json())
      .then((responseText) => {
        successCallback(responseText);
      })
      .catch(function(err){
        failCallback(err);
      });
  },
  newToFixed:function (num,count){
    if(count == undefined){
        count = 2
    }
    if(num==undefined||num=="-"||num==""||num=="--"||num==null||num=="null"){
        return '0.00';
    }else{
        var newNum=new Number(num);
        return newNum.toFixed(count); 
    }
  },
  newToFixedOne:function (num,count){
    if(count == undefined){
        count = 2
    }
    if(num==undefined||num=="-"||num==""||num=="--"||num==null||num=="null"){
        return '0.0';
    }else{
        var newNum=new Number(num);
        return newNum.toFixed(count); 
    }
  },
  fomatFloat:function (num,count){
    if(count == undefined){
      count = 2
    }
    if(num==undefined||num=="-"||num===""||num=="--"||num==null||num=="null"){
        return "--";
    }else{
      var newNum=new Number(num);
      return newNum.toFixed(count);
        
    } 
  },
  fomatFloat100:function (num,count){
    if(count == undefined){
      count = 2
    }
    if(num!=undefined&&num!="-"&&num!=""&&num!="--"&&num!=null&&num!="null"){
      var newNum=new Number(num);
      if (num-0>100) {
        return newNum.toFixed(0);
      } else {
        return newNum.toFixed(count);
      }
    }else{
        return "--";
    } 
  },
  formatStr:function (num){
    if(num==undefined||num=="-"||num==""||num=="--"||num==null||num=="null"||num=='无法计算'){
      if(num=='无法计算'){
        return "0.00";
      }
      return "--";
    }else{
      return String(num)
    } 
  },
  dateMD:(date)=>{
    if (date==''||date==null||date=='--'||date=='--'||date==undefined) {return '--';}
    if ( isNaN(date)) {
      let  k=/^(\d{4})\-([\d]+)\-([\d]+)$/
      let  reg = date.match(/^(\d{4})\-([\d]+)\-([\d]+)$/);
      if(!k.test(date) || reg[2]>12 || reg[3]>31){

      }else{
          return date
      }
    }
    var day,month;
    var currDate = new Date(date);
    month = currDate.getMonth()+1;
    day = currDate.getDate();
    return  month+'月'+day+'日'
  },
  TimeFormat: (startDate, afterDate) => {
    //格式化当前日期
    let nowYear = new Date().getFullYear();
    let nowMonth = parseInt(new Date().getMonth()) + 1;
    let nowDay = new Date().getDate();
    if(nowMonth < 10) {
      nowMonth = "0" + nowMonth;
    }
    if(nowDay < 10) {
      nowDay = "0" + nowDay;
    }
    let nowDate = String(nowYear) + String(nowMonth) + String(nowDay);

    //格式化开始日期
    if(startDate == null || startDate == undefined || startDate == "") {
      startDate = "19000101";
    }else {
      if(startDate instanceof Date) {
        let year = startDate.getFullYear();
        let month = parseInt(startDate.getMonth()) + 1;
        let day = startDate.getDate();
        if(month < 10) {
          month = "0" + month;
        }
        if(day < 10) {
          day = "0" + day;
        }
        startDate = String(year) + String(month) + String(day);
      }else {
        if(startDate.indexOf("-") != -1) {
          startDate = startDate.split("-")[0] + startDate.split("-")[1] + startDate.split("-")[2];
        }else if(startDate.indexOf("/") != -1) {
          startDate = startDate.split("/")[0] + startDate.split("/")[1] + startDate.split("/")[2];
        }
      }
    }

    //格式化结束日期
    if(afterDate == null || afterDate == undefined || afterDate == "") {
      afterDate = "20991231";
    }else {
      if(afterDate instanceof Date) {
        let year = afterDate.getFullYear();
        let month = parseInt(afterDate.getMonth()) + 1;
        let day = afterDate.getDate();
        if(month < 10) {
          month = "0" + month;
        }
        if(day < 10) {
          day = "0" + day;
        }
        afterDate = String(year) + String(month) + String(day);
      }else {
        if(afterDate.indexOf("-") != -1) {
          afterDate = afterDate.split("-")[0] + afterDate.split("-")[1] + afterDate.split("-")[2];
        }else if(afterDate.indexOf("/") != -1) {
          afterDate = afterDate.split("/")[0] + afterDate.split("/")[1] + afterDate.split("/")[2];
        }
      }
    }

    //返回状态
    if(nowDate < startDate) {
      return 0;
    }
    if(nowDate > afterDate) {
       return 2;
    }
    if(nowDate >= startDate && nowDate <= afterDate) {
       return 1;
    }
  },
  deepType(obj) {
    var toString = Object.prototype.toString;
    var map = {
        '[object Boolean]'  : 'boolean', 
        '[object Number]'   : 'number', 
        '[object String]'   : 'string', 
        '[object Function]' : 'function', 
        '[object Array]'    : 'array', 
        '[object Date]'     : 'date', 
        '[object RegExp]'   : 'regExp', 
        '[object Undefined]': 'undefined',
        '[object Null]'     : 'null', 
        '[object Object]'   : 'object'
    };
    return map[toString.call(obj)];
  },
  deepClone(data) {
    var t = this.deepType(data), o, i, ni;
    
    if(t === 'array') {
        o = [];
    }else if( t === 'object') {
        o = {};
    }else {
        return data;
    }
    
    if(t === 'array') {
        for (i = 0, ni = data.length; i < ni; i++) {
            o.push(this.deepClone(data[i]));
        }
        return o;
    }else if( t === 'object') {
        for( i in data) {
            o[i] = this.deepClone(data[i]);
        }
        return o;
    }
  },
  returnDate(date,type){
    if (date==''||date==null||date=='--'||date=='--'||date==undefined) {return '--';}

    if ( isNaN(date)) {
      let  k=/^(\d{4})\-([\d]+)\-([\d]+)$/
      let  reg = date.match(/^(\d{4})\-([\d]+)\-([\d]+)$/);
      if(!k.test(date) || reg[2]>12 || reg[3]>31){

      }else{
          return date
      }
    }
    let num = Number(date)
    // let a=new Date(num);
    // let b=new Date();
    // if ( a.getTimezoneOffset()!=b.getTimezoneOffset()) {
    //   num=Number(data+216000000)
    //   alert('夏令时')
    // } 
    if(type){
      var resultDate,year,month,date,hms,resultDateTemp;
      var currDate = new Date(num);
      year = currDate.getFullYear();
      month = currDate.getMonth()+1;
      date = currDate.getDate();
      if (currDate.getMinutes()<10) {
        hms = currDate.getHours() + ':0' + currDate.getMinutes();
      } else {
        hms = currDate.getHours() + ':' + currDate.getMinutes();
      }
      month = (month < 10) ? ('0' + month) : month;
      date = (date < 10) ? ('0' + date) : date;
      resultDate = year + '-'+month+'-'+date+' ' + hms;
      resultDateTemp = year + '-'+month
      if(type == "M"){
        return resultDateTemp;
      }else{
        return resultDate;
      }
    }else{
      var resultDate,year,month,date,hms;
      var currDate = new Date(num);
      year = currDate.getFullYear();
      month = currDate.getMonth()+1;
      date = currDate.getDate();
      month = (month < 10) ? ('0' + month) : month;
      date = (date < 10) ? ('0' + date) : date;
      resultDate = year + '-'+month+'-'+date;
      // alert(currDate) 
      return resultDate;
    }
  },
  cutReturn(title,width,fontSize){
    let x=Math.floor(width/fontSize);
    if (title.length>=x) {
      return title.substr(0,x)+'...'
    }
    return title
  },
  /*金钱数目打千分位符*/
  thousandCount(num) {
    num = String(num);
    if(Number(num) == 0 || isNaN(Number(num))){
      num = '0.00';
      return num;
    }
    console.log(Number(num));
    num = this.formatStr(num);
    num = num.replace(/,/g,'');
    if(Number(num)){
      num = Number(num).toFixed(2);
    }
    let parts = num.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  },
  thousandCount4(num) {
    num = String(num);
    if(Number(num) == 0 || isNaN(Number(num))){
      num = '0.0000';
      return num;
    }
    console.log(Number(num));
    num = this.formatStr(num);
    num = num.replace(/,/g,'');
    if(Number(num)){
      num = Number(num).toFixed(4);
    }
    let parts = num.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return parts.join('.');
  },
  isIDCard: /^([1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3})|([1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X|x))$/,
  isMobileNo: /^1[0123456789]\d{9}$/,
  passwordPattern:  /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{6,8}$/,
  superFundCodeArr: ["SF1001", "SF1002", "SF1003", "SF1004", "SF1005", "SF1006", "SF1007", "SF1008", "SF1009", "SF1010", "SF1011", "SF1017", "SF1018", "SF1019", "SF1020", "SF1021", "SF1013", "SF1012", "SF1015", "SF1016", "SF1014","SF1036","SF1038","SF1039","SF1060","SF1067","SF1022"],
  superFundCodeArrByYl: ["SF1006", "SF1007", "SF1008", "SF1019", "SF1020", "SF1021", "SF1013"],
  superFundCodeArrByJy: ["SF1009", "SF1010", "SF1011", "SF1017", "SF1018"],
  superFundCodeArrByZl: ["SF1001", "SF1002", "SF1003", "SF1004", "SF1005", "SF1012", "SF1015", "SF1016", "SF1014","SF1036","SF1038","SF1039","SF1060","SF1067","SF1022"],
  superFundCodeArrByTarget: ["SF10A1","SF10A2","SF10A3","SF10A4","SF10A5","SF10A6","SF10A7","SF10A8","SF10A9","SF10B1","SF10B2","SF10B3","SF10B4","SF10B5","SF10B6","SF10B7","SF10B8","SF10B9","SF10C1","SF10C2","SF10C3","SF10C4","SF10C5","SF10C6","SF10C7","SF10C8","SF10C9","SF10D1","SF10D2","SF10D3","SF10D4","SF10D5","SF10D6","SF10D7","SF10D8","SF10D9","SF10E1","SF10E2","SF10E3","SF10E4","SF10E5","SF10E6","SF10E7","SF10E8","SF10E9"],
  superFundCodeArrByTargetName: ["小常乐目标盈008期","小常乐目标盈009期","小常乐目标盈010期","小常乐目标盈011期","小常乐目标盈012期","小常乐目标盈013期","小常乐目标盈014期","小常乐目标盈015期","小常乐目标盈016期","小常乐目标盈017期","小常乐目标盈018期","小常乐目标盈019期","小常乐目标盈020期","小常乐目标盈021期","小常乐目标盈022期","小常乐目标盈023期","小常乐目标盈024期","小常乐目标盈025期","小常乐目标盈026期","小常乐目标盈027期","小常乐目标盈028期","小常乐目标盈029期","小常乐目标盈030期","小常乐目标盈031期","小常乐目标盈030期","小常乐目标盈031期","小常乐目标盈","小常乐目标盈032期","小常乐目标盈033期","小常乐目标盈034期","小常乐目标盈035期","小常乐目标盈036期","小常乐目标盈037期","小常乐目标盈038期","小常乐目标盈039期","小常乐目标盈040期","小常乐目标盈041期","小常乐目标盈042期","小常乐目标盈","小常乐目标盈043期","小常乐目标盈044期","小常乐目标盈045期","小常乐目标盈046期","小常乐目标盈047期","小常乐目标盈048期"],
  superFundCodeArrByYlName: ["老60后智享财富组合", "老70后智赢人生组合", "老80后智领未来组合", "60后智享财富组合", "70后智赢人生组合", "80后智领未来组合", "90后智享自由组合"],
  superFundCodeArrByJyName: ["雏鹰初中生组合", "菁英高中生组合", "常青藤大学组合", "国内培优教育金组合", "常青藤教育金组合"],
  superFundCodeArrByZlName: ["", "安逸理财组合", "均衡稳健组合", "", "锐意进取组合", "货币优享组合", "固收增强组合", "权益优选组合", "指数轮动组合","工资宝绝对收益组合","7分小进取组合","指数增强组合","安心宝组合","价值精选组合","货币增强组合"],
  superFundCodeArrByZX: ["SF1012", "SF1013","SF1014","SF1015","SF1016","SF1017","SF1018","SF1019","SF1020","SF1021"],
  superFundNameArr: ["", "安逸理财组合", "均衡稳健组合", "", "锐意进取组合", "老60后智享财富组合", "老70后智赢人生组合", "老80后智领未来组合", "雏鹰初中生组合", "菁英高中生组合", "常青藤大学组合", "国内培优教育金组合", "常青藤教育金组合", "60后智享财富组合", "70后智赢人生组合", "80后智领未来组合", "90后智享自由组合", "货币优享组合", "固收增强组合", "权益优选组合", "指数轮动组合","工资宝绝对收益组合","7分小进取组合","指数增强组合","安心宝组合","价值精选组合","货币增强组合"],
  superFundTextArr: (code, component) => { //文案暂定
    let text = "";
    if(component == "Transfer" || component == "TransferF") {
      switch(code) {
        case "SF1012":
          text = ["货币优享组合", "wjPie.png"];
          break;
        case "SF1013":
          text = ["90后", "80Pie.png"];
          break;
        case "SF1014":
          text = ["指数轮动", "wjPie.png"];
          break;
        case "SF1015":
          text = ["固收增强组合", "wjPie.png"];
          break;
        case "SF1016":
          text = ["权益优选", "wjPie.png"];
          break;
        case "SF1017":
          text = ["国内培优", "dxJyPie.png"];
          break;
        case "SF1018":
          text = ["常青藤", "dxJyPie.png"];
          break;
        case "SF1019":
          text = ["60后", "60Pie.png"];
          break;
        case "SF1020":
          text = ["70后", "70Pie.png"];
          break;
        case "SF1021":
          text = ["80后", "80Pie.png"];
          break;
        default:
          text = ["", "wjPie.png"];
      }
    }
    return text;
  },

  // toPercent:(value)=>{
  //   if(value===0) return '0.00%'
  //   if(!value) return '--'
  //   const _value=value
  //   console.log('5555555',value)
  //   const percentageArr=Math.abs(value).toFixed(4).toString().split('.')
  //   console.log('666666',percentageArr)
  //   percentageArr[0]+=percentageArr[1].slice(0,2);
  //   percentageArr[0]=parseInt(percentageArr[0])
  //   percentageArr[1]=percentageArr[1].slice(2)
  //   if(_value>0) return  `${percentageArr.join('.')}%`
  //   return `-${percentageArr.join('.')}%`
  // },

  toPercent:(val,count=2)=>{
    console.log('---------------',val)
    if (typeof val === "number" || (typeof val === "string" && parseFloat(val) == val)) {
      if (val - 0 === 0) return (val - 0).toFixed(count) + "%";
      const _value = val;
      const valueArr = Math.abs(val).toString().split(".");
      console.log('---------------',val,valueArr)
      let resultArr = null;
      if (valueArr[1] && valueArr[1].length > count + 2) {
        valueArr[1] = valueArr[1].slice(0, count + 2);
        resultArr=valueArr
      } else
      resultArr = Math.abs(val).toFixed(count + 2).toString().split(".");
      console.log('---------------',val,resultArr)
      console.log('---------------',[parseInt(resultArr[0] + resultArr[1].slice(0, 2)),resultArr[1].slice(2)].join('.')+'%')
      return (_value<0?'-':'')+[parseInt(resultArr[0] + resultArr[1].slice(0, 2)),resultArr[1].slice(2)].join('.')+'%'
    }
    return "--";
  },
  processingDecimal :(val,count=2,hasRight=false)=>{
    if (typeof val === "number" || (typeof val === "string" && parseFloat(val) == val)) {
      if (val - 0 === 0) return (hasRight ? "+" : "") + (val - 0).toFixed(count);
      const dot = val.toString().split(".");
      let result;
      if (dot[1] && dot[1].length > count) {
        dot[1] = dot[1].slice(0, count);
        result = dot.join(".");
      }
      result = (val - 0).toFixed(count);
      return (hasRight && val >= 0 ? "+" : "") + result;
    }
    return "--";
  },
  pieEchartsColorMap:new Map([
    ['股票型','#F8515C'],//股票型
    ['债券型','#796EE0'],//债券型
    ['货币型','#5BA3F6'],//货币型
    ['混合型','#FF9653'],//混合型
    ['QDII基金','#F8515C'],//QDII
  ]),
  pieEchartsFundListColorMap:new Map([
    ['股票型','linear-gradient(270deg, rgba(255, 227, 227, 0) 0%, #FFE3E3 100%)'], 
    ['债券型','linear-gradient(270deg, rgba(227, 225, 255, 0) 0%, #E3E0FF 100%)'],
    ['货币型','linear-gradient(270deg, rgba(224, 231, 255, 0) 0%, #E0E7FF 100%)'],
    ['混合型','linear-gradient(270deg, rgba(255, 226, 208, 0) 0%, #FFE2D0 100%)'],
    ['QDII基金','linear-gradient(270deg, rgba(255, 227, 227, 0) 0%, #FFE3E3 100%)'],
  ]),
  pieEchartsFundListBgColorMap:new Map([
    ['股票型','#FFFBFB'], 
    ['债券型','#FAFAFF'],
    ['货币型','#FAFBFF'],
    ['混合型','#FFFBF8'],
    ['QDII基金','#FFFBFB'], 
  ]),
  returnEmpty: (num, val) => {
   if(num === "" || num === null || num === undefined) {
    if(val === "" || val === null || val === undefined) {
      return "--";
    }else {
      if(val == "%") {
        return "--%";
      }else if(val == "fixed") {
        return "--";
      }else {
        return "--" + val;
      }
    }
   }else {
    if(val === "" || val === null || val === undefined) {
      return num;
    }else {
      if(val == "%") {
        return (num * 100).toFixed(2) + val;
      }else if(val == "fixed") {
        return Number(num).toFixed(2);
      }else {
        return num + val;
      }
    }
   }
  },
  returnEmptyAlone:(num) => {
    if(num === null || num === "" || num === undefined) {
      return false;
    }else {
      return true
    }
  },
  keepfomatFloat:function (num,count){
    if(count == undefined){
      count = 2
    }
    if(num!=undefined&&num!="-"&&num!==""&&num!="--"&&num!=null&&num!="null"){
        var newNum=new Number(num);
        if(newNum >0){
          return "+"+newNum.toFixed(count)+"%";
        }else{
          return newNum.toFixed(count)+"%";
        }
    }else{
        return "--";
    } 
  },
  Keepwodecimalplaces:(val) =>{
    if(val !=null ){
      let  A=val.toString()
        let s=A.slice(0,1) === "-" ? Number(A.slice(1)):Number(A)
        if(s=='0'){
          return '0.00'
        }else if(s!=undefined&&s!="-"&&s!=""&&s!=null&&s!='--') {
         let a = Math.floor(module.exports.percentFormatFun(s,100))
          s=module.exports.percentFormatFunSec(a,100)
          let n = 2
           s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(n) + "";   
           let k= A.slice(0,1) === "-" ?"-"+s:s
           return  k
        }else{
          return "0.00";
      }
    }
  },
   //保留四位小数
   Retainfourdecimalplaces:(val) =>{
    if(val !=null ){
      let  A=val.toString()
        let s=A.slice(0,1) === "-" ? Number(A.slice(1)):Number(A)
        if(s=='0'){
          return '0.0000'
        }else if(s!=undefined&&s!="-"&&s!=""&&s!=null&&s!='--') {
        let a = Math.floor(module.exports.percentFormatFun(s,10000))
          s=module.exports.percentFormatFunSec(a,10000)
          let n = 4
          s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(n) + "";   
          let k= A.slice(0,1) === "-" ?"-"+s:s
          return  k
        }else{
          return "0.0000";
      }
    }
  },
  /*交易记录详情金额转换打千分位符保留两位小数*/
TRparsePrice:function(s, isFloat){
  if(s!=undefined&&s!="-"&&s!=""&&s!=null&&s!='--') {
    let a = Math.floor(module.exports.percentFormatFun(s,100))
     s=module.exports.percentFormatFunSec(a,100)
     let n = 2
      s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(n) + "";   
      var l = s.split(".")[0].split("").reverse(),   
      r = s.split(".")[1];   
      let t = ""; 
      if (s>=0) {//正负
           for(let i = 0; i < l.length; i ++ ){   
             t += l[i] + ((i + 1) % 3 == 0 && (i + 1) != l.length ? "," : "");   
           }   
           if(isFloat != undefined) {
             return t.split("").reverse().join("");
           }else {
             return t.split("").reverse().join("") + "." + r;
           }
      } else{
           for(let i = 0; i < l.length-1; i ++ ){   
             t += l[i] + ((i + 1) % 3 == 0 && (i + 1) != l.length-1 ? "," : "");  
           }  
           if(isFloat != undefined) {
             return "-"+t.split("").reverse().join("");
           }else {
             return "-"+t.split("").reverse().join("") + "." + r;
           }
      };    
   }else{
       return "0.00";
   }
 },
  //加百分比
  fomatFloatpercentage:function (num,count){
    if(count == undefined){
      count = 2
    }
    if(num!=undefined&&num!="-"&&num!==""&&num!="--"&&num!=null&&num!="null"){
        var newNum=new Number(num);
        return newNum.toFixed(count)+"%";
    }else{
        return "--";
    } 
  },
  //乘
  percentFormatFun: (val, per) => {
    if(module.exports.returnEmptyAlone(val) === false) {return '--';}
    if(val === 0 || val === "0" || val === "0.0" || val === "0.00") {
      return "0";
    }
    let _flag = true;
    if(val < 0) {
      _flag = false;
      val = val * -1;
    }
    //原数
    let _val = val.toString();
    //10的n次幂
    let _per  = per.toString();
    //几个0
    let perZero = _per.length - 1;
    //小数时
    if(_val.indexOf(".") != -1) {
      //0的位数大于等于小数点后位数
      if(perZero >= _val.split(".")[1].length) {
        //多出的位数
        let _the = perZero - _val.split(".")[1].length;
        //大于则去掉小数点后面直接追加0,等于则去掉小数点即可
        let _sec = _the > 0 ? _per.substr(1, _the) : "";
        let lastVal = _val.split(".")[0] + _val.split(".")[1] + _sec;
        //去掉前面的0
        for(let i = 0; i < lastVal.length; i++) {
          if(lastVal[i] != 0) {
            if(_flag === true) {
              return lastVal.substr(i, lastVal.length - i);
            }else {
              return "-" + lastVal.substr(i, lastVal.length - i);
            }
          }
        }
      }else {
        //小数点前的位数加上所有0就是最后小数点前的位数
        let _theSec = _val.split(".")[0].length - 0 + perZero;
        let newVal = _val.split(".")[0] + _val.split(".")[1];
        //获得小数点前最终的值
        let lastValSec = newVal.substr(0, _theSec);
        //去掉前面的0
        for(let i = 0; i < lastValSec.length; i++) {
          if(lastValSec[i] > 0) {
            if(_flag === true) {
              return lastValSec.substr(i, lastValSec.length - i) + "." + newVal.substr(_theSec, newVal.length - _theSec);
            }else {
              return "-" + lastValSec.substr(i, lastValSec.length - i) + "." + newVal.substr(_theSec, newVal.length - _theSec);
            }
          }else {
            if(i == lastValSec.length - 1) {
              if(_flag === true) {
                return "0" + "." + newVal.substr(_theSec, newVal.length - _theSec);
              }else {
                return "-0" + "." + newVal.substr(_theSec, newVal.length - _theSec);
              }
            }
          }
        }
      }
    }else {
      //非小数 直接 追加0
      if(_flag === true) {
        return _val + _per.substr(1, perZero);
      }else {
        return "-" + _val + _per.substr(1, perZero);
      }
    }
  },
  //除
  percentFormatFunSec: (val, per) => {
    if(module.exports.returnEmptyAlone(val) === false) {return '--';}
    if(val === 0 || val === "0" || val === "0.0" || val === "0.00") {
      return "0";
    }
    let _flag = true;
    if(val < 0) {
      _flag = false;
      val = val * -1;
    }
    //原数
    let _val = val.toString();
    //10的n次幂
    let _per  = per.toString();
    //几个0
    let perZero = _per.length - 1;
    //小数时
    if(_val.indexOf(".") != -1) {
      //0的位数小于等于小数点前位数
      if(perZero <= _val.split(".")[0].length) {
        //多出的位数
        let _the = _val.split(".")[0].length - perZero;
        let firVal = _the > 0 ? _val.split(".")[0].substr(0, _the) + "." + _val.split(".")[0].substr(_the, _val.split(".")[0].length - _the) + _val.split(".")[1] : "0." + _val.split(".")[0] + _val.split(".")[1];
        if(_flag === true) {
          return firVal;
        }else {
          return "-" + firVal;
        }
      }else {
        let _the = perZero - _val.split(".")[0].length;
        let firVal = "0." + _per.substr(1, _the) + _val.split(".")[0] + _val.split(".")[1];
        if(_flag === true) {
          return firVal;
        }else {
          return "-" + firVal;
        }
      }
    }else {
      //非小数 
      if(perZero <= _val.length) {
        //多出的位数
        let _the = _val.length - perZero;
        let firVal = _the > 0 ? _val.substr(0, _the) + "." + _val.substr(_the, _val.length - _the) : "0." + _val.split(".")[0];
        if(_flag === true) {
          return firVal;
        }else {
          return "-" + firVal;
        }
      }else {
        let _the = perZero - _val.length;
        let firVal = "0." + _per.substr(1, _the) + _val;
        if(_flag === true) {
          return firVal;
        }else {
          return "-" + firVal;
        }
      }
    }
  },
  //管家在卖产品
  kycFundListByGJ: ["SF1022", "SF1015", "SF1016", "SF1014", "SF1017", "SF1018", "SF1019", "SF1020", "SF1021", "SF1013"],
  // 身份证上传压缩
  compressPicture: files => {
    return new Promise((resolve, reject) => {
      if (!files[0]) return false;
      let imgSIze = files[0].file.size / 1024 / 1024;
      if (imgSIze > 5) {
        return Toast.info('请上传5M以内的照片', module.exports.ToastTime);
      }
      console.log(imgSIze);
      if (imgSIze > 0.15) {
        // 压缩
        try {
          let image = new Image();
          var fileReader = new FileReader();
          fileReader.readAsDataURL(files[0].file);
          fileReader.onload = function (e) {
            image.src = e.target.result;
            // 压缩
            image.onload = function () {
              let square = 500,
                canvas = document.createElement('canvas'),
                context = canvas.getContext('2d');

              context.clearRect(0, 0, square, square);
              if (this.width > square || this.height > 500) {
                if (this.width >= this.height) {
                  canvas.width = square;
                  canvas.height = square * (this.height / this.width);
                  context.drawImage(
                    this,
                    0,
                    0,
                    square,
                    square * (this.height / this.width)
                  );
                } else {
                  canvas.height = square;
                  canvas.width = square * (this.width / this.height);
                  context.drawImage(
                    this,
                    0,
                    0,
                    square * (this.width / this.height),
                    square
                  );
                }
              } else {
                canvas.height = this.width;
                canvas.width = this.height;
                context.drawImage(this, 0, 0, this.width, this.height);
              }

              let imgBase64 = canvas.toDataURL(files[0].file.type);

              canvas.toBlob(
                blob => {
                  blob.name = files[0].file.name;
                  console.log(blob, '11111111');
                  resolve({ file: blob, url: imgBase64 });
                },
                // files[0].file.type
                'image/jpeg'
              );
            };
          };
        } catch (e) {
          reject('请正确上传本人有效证件');
          // Toast.fail('请正确上传本人有效证件', Util.ToastTime);
        }
      } else {
        // 预览
        let fileReader = new FileReader();
        fileReader.readAsDataURL(files[0].file);
        fileReader.onload = function (e) {};
        // 存储文件对象
        resolve(files[0]);
      }
    });
  }
};



// WEBPACK FOOTER //
// ./src/util.js